export default "__VITE_ASSET__BIeSeeh___"